import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  text-align: center;
`;

export const CodeWrapper = styled.div`
  width: 100%;
  max-width: 160px;
  margin: 0 auto;
  padding: 16px;
  background: white;
  border-radius: var(--border-radius);
  line-height: 0;

  svg {
    width: 100%;
  }
`;

export const ShortId = styled.p`
  margin: var(--gap) 0 0;
  font-weight: 700;
  user-select: text;
`;
